const { default: _default,ENDPOINT,SCHEMA_VERSION,useTracking,useViewerDataEventual } = crateImports["@xing-com/crate-communication-tracking"];
export { _default as default,ENDPOINT,SCHEMA_VERSION,useTracking,useViewerDataEventual };